import { com } from '@eidu/form'
import type { SxProps, Theme } from '@mui/material'
import React from 'react'
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId
import MultiSelect from '../input/MultiSelect'

export type EntityTypeDisplayProps = {
  availableEntityTypes: readonly EntityType[]
  selectedEntityTypes: readonly EntityTypeId[]
  label: string
  labelId: string
  sx?: SxProps<Theme>
}

const EntityTypeDisplay = ({
  availableEntityTypes,
  selectedEntityTypes,
  label,
  labelId,
  sx,
}: EntityTypeDisplayProps) => (
  <MultiSelect
    available={availableEntityTypes.map((it) => ({ [it.name]: it.id }))}
    selected={selectedEntityTypes}
    setSelected={() => {}}
    equals={(value: EntityTypeId, other: EntityTypeId) => value.toString() === other.toString()}
    label={label}
    labelId={labelId}
    disabled
    sx={sx}
  />
)

export default EntityTypeDisplay
